import { ArrowUpRight, X } from "lucide-react";
import { useServerStatus } from "@/context/ServerStatusContext";
import { useContent } from "@/context/ContentContext";
import { useText } from "@/lib/useText";

export function OnlineBanner() {
  const { cameOnline, dismissOnline, players, max_players } = useServerStatus();
  const { content } = useContent();
  const t = useText();
  if (!cameOnline) return null;
  return (
    <div role="status" aria-live="polite" className="border-b border-emerald-500/30 bg-emerald-500/10 animate-fade-up" data-testid="online-banner">
      <div className="container-eden flex items-center gap-4 py-2.5">
        <span className="h-2 w-2 shrink-0 rounded-full bg-emerald-400 animate-pulseDot" aria-hidden="true" />
        <p className="flex-1 text-sm text-eden-text">
          <span className="font-semibold">{t("banner_title")}</span>{" "}
          <span className="text-eden-secondary">{players} de {max_players} {t("banner_text")}</span>
        </p>
        <a href={content?.links?.fivem_join} target="_blank" rel="noopener noreferrer" className="inline-flex h-8 items-center gap-1 rounded-sm bg-eden-orange px-3 font-display text-xs font-semibold uppercase tracking-wider text-eden-bg hover:bg-eden-orangeHover" data-testid="online-banner-play">
          {t("banner_button")} <ArrowUpRight size={14} aria-hidden="true" />
        </a>
        <button type="button" onClick={dismissOnline} className="btn-ghost h-8 px-2" aria-label="Fechar aviso" data-testid="online-banner-dismiss"><X size={16} /></button>
      </div>
    </div>
  );
}
